import Navbar from '../navigation/Navbar';
import Footer from '../../components/app/Footer';
import toList from '../utils/ComponentUtil';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import JobDesc from '../DailyJobs/JobDesc';
import TalentsAPI from '../Apis/TalentsAPI';
import reviewWritingImg from "../../images/review-writing.png";
import UnorderedList from '../utils/UnorderedList';
import CustomAccordion from '../utils/CustomAccordion';
import Categories from "../app/Categories";
import './FAQ.scss';
import Header from '../utils/Header';
import Blogs from '../app/Blogs';



function FAQPage() {

    const talents = TalentsAPI.getTalents();
    const faq = {
        name: "Google Advertisement",
        jobImg: reviewWritingImg,
        talentsTitle: 'Recent Talents',
        talents: [...talents, ...talents, ...talents.slice(2)]
    };

    const faqs = [{
        id: 1,
        question: <div>How is jobfi.in different from other job-providing platforms?</div>,
        answer: <>
            jobfi.in is distinct from other web career boards in several aspects.
            <UnorderedList title='' compensation={['Our job board aims to provide better employment opportunities. Thus, we thoroughly screen every accessible position before approving it. This is published by an actual individual who spends up to 30 minutes per job, making sure it passes our stringent standards.', 'The platform is user-friendly and easy-to use. You won\'t have to filter through work postings for keywords like "flexible" or "remote" for hours. Just login to find the most recent, remote, part-time, freelance, and other versatile jobs available.']} />
        </>
    },
    {
        id: 2,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 3,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 4,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 5,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 6,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 7,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 8,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 9,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 10,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 11,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 12,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 13,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 14,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 15,
        question: "Is jobfi.in a staffing firm or a recruitment firm ?",
        answer: "The evaluation process takes approximately 24 hours."
    },
    {
        id: 16,
        question: "How long does it take for the result of my application to be out?",
        answer: "The evaluation process takes approximately 24 hours."
    }
    ]

    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography>FAQ's</Typography>]

    return (
        <>
            <Navbar selected='Help'/>
            <JobDesc {...faq} header={<Header title='Frequently Asked Question’s' subTitle='Clear your answers here'/>} breadcrumbs={breadcrumbs} startPosting={false} render={() => <div className='faq-home-content-wrp'>
                <CustomAccordion accordians={toList(faqs, undefined, (item, i) => {
                    return {
                        summary: <div className='accordian-summary'>
                            <div className='question-no'>{i + 1}</div>
                            <div>{item.question}</div>
                        </div>,
                        details: <div className='accordian-details'>{item.answer}</div>
                    }
                })}></CustomAccordion>
                <div className='please-note-wrp'>
                    <div className='title'>Please Note</div>
                    <div className='content'>
                    <UnorderedList title='' compensation={[
                        'jobfi.in Membership Fee is 100% Free.',
                        'There is no Membership/Registration cost. so, don\'t pay Money in the name of jobfi.in',
                        'Also, it is not a Get Rich Quick Scheme nor it is a Multi Level Marketing(MLM), Matrix, Pyramid Program but it helps you to Earn some extra income on your Part time thru online.']} />
                    </div>
                </div>
                <div className='any-questions-wrp'>
                    <div className='title'>If you have any questions?</div>
                    <div className='content'>
                        <span>We are ready to help you in clearing your doubts. Kindly contact</span><span className='email'> support@jobfi.in</span>
                    </div>
                </div>
            </div>}></JobDesc>
            <Blogs></Blogs>
            <Categories></Categories>
            <Footer></Footer>
        </>
    );
}

export default FAQPage;